import { render, staticRenderFns } from "./StoryViewPage.vue?vue&type=template&id=13f2015e&scoped=true"
import script from "./StoryViewPage.vue?vue&type=script&lang=js"
export * from "./StoryViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f2015e",
  null
  
)

export default component.exports